import i from "axios";
const u = () => {
  var t;
  return typeof document < "u" && ((t = document.querySelector('meta[name="csrf-token"]')) == null ? void 0 : t.getAttribute("content")) || null;
}, d = () => {
  var t, r, n;
  if (typeof window < "u") {
    const e = "_anyroad_embedded_session_key", o = sessionStorage.getItem(e);
    if (o) return o;
    const s = (n = (r = (t = document.cookie) == null ? void 0 : t.split("; ")) == null ? void 0 : r.find((c) => c.startsWith(`${e}=`))) == null ? void 0 : n.split("=")[1];
    if (s) return s;
    const a = localStorage.getItem(e);
    if (a) return a;
  }
  return process.env.ANYROAD_SESSION_TOKEN || null;
}, p = (t) => typeof t == "string" && t.trim().length > 0, l = () => "https://app.anyroad.com", m = (t, r) => {
  const n = i.create({
    baseURL: l(),
    // Get base URL at runtime
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    ...r
  });
  return n.interceptors.request.use((e) => {
    e.headers = e.headers || {};
    const o = d();
    p(o) && (e.headers.Authorization = `Bearer ${o}`);
    const s = u();
    return s && (e.headers["X-CSRF-Token"] = s), e;
  }), n(t).then((e) => e.data).catch((e) => {
    throw e;
  });
};
export {
  m as customInstance
};
